export const file = {
    "file_Files": "Files",
    "file_ShareFiles": "Share Files",
    "file_DeleteFiles": "Deleted Files",
    "file_s'folder": " 'Folder",
    "file_my_folder": "My Folder",
    "file_s'_shareRoot": " 'Share Folder",
    "empty_file": "Empty Files",
    "file_table_col_Name": "Name",
    "file_table_col_Size": "Size",
    "file_table_col_CreatedBy": "CreatedBy",
    "file_table_col_CreateTime": "CreateTime",
    "file_table_col_Reads": "Reads",
    "file_table_col_Option": "Option",
    "file_table_col_Option_Rename": "Rename",
    "file_table_col_Option_Move": "Move",
    "file_table_col_Option_Share": "Share",
    "file_table_col_Option_Auth_Share": "Auth Share",
    "file_table_col_Option_Delete": "Delete",
    "file_sort_click_sort_by": "Click Sort by...",
    "file_sort_by_name": "Sort by Name",
    "file_sort_by_size": "Sort by Size",
    "file_sort_by_type": "Sort by Type",
    "file_admin_btn_create": "Create Folder",
    "file_admin_btn_add": " Add File",
    "file_admin_btn_add_multi": "Add Multi File",
    "file_view_list": "List Mode",
    "file_view_cards": "Card Mode",
    "file_share_modal_title": "View Page Shares ({{count}} shares)",
    "file_share_modal_list": "List",
    "file_share_modal_cards": "Cards",
    "file_share_modal_close": "Close",
    "file_share_modal_selected": "{{count}} selected",
    "file_share_modal_batch_delete": "Batch Delete",
    "file_share_modal_no_shares": "No shared files on this page",
    "file_share_modal_share_user": "Share User",
    "file_share_modal_share_group": "Share Group",
    "file_share_modal_share": "Share",
    "file_share_modal_time": "Time",
    "file_share_modal_no_expiration": "No Expiration",
    "file_share_modal_expires": "Expires",
    "file_share_modal_remark": "Remark",
    "file_share_modal_share_by": "Share By",
    "file_share_modal_delete": "Delete",
    "file_share_modal_shares_count": "{{count}} shares",
    "file_share_modal_type_user": "User",
    "file_share_modal_type_group": "Group",
    "file_share_modal_type_password": "Password",
    "file_share_modal_password_share": "Password Share",
    "file_share_modal_time_range": "Time Range",
    "file_share_modal_expiry_time": "Expiry Time",
    "file_share_modal_never_expires": "Never Expires",
    "file_share_modal_sharer": "Sharer",
    "file_share_modal_fetch_error": "Failed to fetch share information",
    "file_share_modal_delete_success": "Share deleted successfully",
    "file_share_modal_delete_error": "Failed to delete share",
    "file_share_modal_batch_delete_success": "Successfully deleted {{count}} shares",
    "file_share_modal_batch_delete_error": "Failed to delete {{count}} shares",
    "file_share_create_modal_title": "File Sharing Settings: ",
    "file_share_create_modal_batch_title": "Batch Share Settings ({{count}} files)",
    "file_share_create_modal_file_list": "File List",
    "file_share_create_modal_create_new": "Create New Share",
    "file_share_create_modal_share_type": "Share Type",
    "file_share_create_modal_user": "User",
    "file_share_create_modal_group": "Group",
    "file_share_create_modal_expiry_time": "Expiry Time",
    "file_share_create_modal_custom_expiry": "Custom Expiry",
    "file_share_create_modal_start_date": "Start Date",
    "file_share_create_modal_end_date": "End Date",
    "file_share_create_modal_remark": "Remark",
    "file_share_create_modal_remark_placeholder": "Enter remark",
    "file_share_create_modal_create_share": "Create Share",
    "file_share_create_modal_current_shares": "Current Shares",
    "file_share_create_modal_custom_time_error": "Custom time period requires selecting a time",
    "file_share_create_modal_share_exists": "This type of share already exists for the selected user or group.",
    "file_share_create_modal_create_success": "Share successfully created",
    "file_share_create_modal_batch_success": "Successfully shared {{count}} files",
    "file_share_create_modal_share_failed": "Share failed",
    "file_share_create_modal_expiry_no_expiration": "No expiration",
    "file_share_create_modal_expiry_custom": "Custom",
    "file_share_create_modal_expiry_6_hours": "6 hours",
    "file_share_create_modal_expiry_1_day": "1 day",
    "file_share_create_modal_expiry_3_days": "3 days",
    "file_share_create_modal_expiry_7_days": "7 days",
    "file_share_create_modal_expiry_14_days": "14 days",
    "file_share_create_modal_expiry_21_days": "21 days",
    "file_share_create_modal_expiry_1_month": "1 month",
    "file_share_create_modal_expiry_3_months": "3 months",
    "file_share_create_modal_expiry_6_months": "6 months",
    "file_share_create_modal_expiry_1_year": "1 year",

    "file_player_back": "← Back to files",
    "file_player_loading": "Loading file…",
    "file_player_loading_title": "Loading preview…",
    "file_player_loading_progress": "Loading {{loaded}}/{{total}}",
    "file_player_progress_file_label": "File",
    "file_player_progress_resource_label": "Player resources",
    "file_player_progress_detail": "{{loaded}}/{{total}} · {{percent}}%",
    "file_player_progress_preparing": "Preparing…",
    "file_player_progress_waiting": "Waiting…",
    "file_player_unauthorized": "You do not have permission to view this file",
    "file_player_load_failed": "Failed to load file",
    "file_player_unsupported": "Preview is not supported for this file type",

    "file_ppt_anim_hint": "Slideshow starts automatically. Click to advance animations step by step; GIFs play in slideshow mode. Remaining differences vs PowerPoint are OnlyOffice compatibility limits.",
    "file_player_initial_loading": "Loading…",

    "file_pdf_mode_single": "Single page",
    "file_pdf_mode_multi": "Tiled",
    "file_pdf_mode_play": "Slideshow",
    "file_pdf_zoom": "Zoom",
    "file_pdf_zoom_fit": "Best fit",
    "file_pdf_zoom_custom": "Custom",
    "file_pdf_zoom_custom_aria": "Custom zoom percentage",
    "file_pdf_prev": "Previous",
    "file_pdf_next": "Next",
    "file_pdf_page_aria": "Page number",
    "file_pdf_exit_play": "Exit slideshow",
    "file_pdf_play_hint": "Click left/right to turn pages · Arrow keys / Space · Esc to exit",
    "file_pdf_loading": "Loading PDF…",
    "file_pdf_load_error": "Failed to load PDF",
    "file_pdf_cannot_load": "Unable to load PDF",
    "file_pdf_multi_hint": "{{count}} pages · Arrow keys sync page",
};

export const fileAuthShareModal = {
    files_AuthShareModal_title: "File Sharing Auth Path: ",
    files_AuthShareModal_alert_message: "Share access permissions with other academic teachers. They will be able to view this folder and all its subfolders. Please double-check before sharing.",
    files_AuthShareModal_unauthorized_teachers: "Unauthorized Teachers",
    files_AuthShareModal_authorized_teachers: "Authorized Teachers",
    files_AuthShareModal_operation_grant: "Grant",
    files_AuthShareModal_operation_revoke: "Revoke",
    files_AuthShareModal_search_placeholder: "Search teachers",
    files_AuthShareModal_success_grant: "{{count}} teacher(s) authorized",
    files_AuthShareModal_success_revoke: "Permissions revoked for {{count}} teacher(s)",
    files_AuthShareModal_error_load: "Failed to load permission data",
    files_AuthShareModal_error_operation: "Operation failed, please try again",
};
